import { render, staticRenderFns } from "./LayoutFront.vue?vue&type=template&id=82aa18c2&"
import script from "./LayoutFront.vue?vue&type=script&lang=js&"
export * from "./LayoutFront.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82aa18c2')) {
      api.createRecord('82aa18c2', component.options)
    } else {
      api.reload('82aa18c2', component.options)
    }
    module.hot.accept("./LayoutFront.vue?vue&type=template&id=82aa18c2&", function () {
      api.rerender('82aa18c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LayoutFront.vue"
export default component.exports